import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import getSearchResults from "api/requests/getSearchResults";
import { Brand } from "custom-types/Brand";
import { MenuItem } from "custom-types/MenuItem";
import useDomainCountryCode from "hooks/useDomainCountryCode";
import { getCoordinates } from "redux/selectors/location";

import Carousel from "components/botanic/Carousel";
import MenuItemCard from "components/botanic/MenuItemCard";
import CartIcon from "components/Icons/cart.svg";
import { MenuItemCardActions } from "components/Shared/MenuItemCarousel/MenuItemCardActions";

type Props = {
  brand: Brand;
};
const ShopNearbySection: React.FC<Props> = ({ brand }) => {
  const [menuItems, setMenuItems] = useState<MenuItem[]>([]);
  const coordinates = useSelector(getCoordinates);
  const countryCode = useDomainCountryCode();

  useEffect(() => {
    const getSearchResultsCall = async () => {
      const { menuItem } = await getSearchResults(
        {
          "filter[brand_slug]": brand.slug,
          "filter[max_distance]": "20",
          "filter[type]": "menu_item",
        },
        coordinates,
        20,
        countryCode,
        12,
        0,
        "serp_shop",
        true
      );

      setMenuItems(menuItem);
    };

    if (brand.slug) {
      getSearchResultsCall();
    }
  }, [brand]);

  const cards = menuItems.map((menuItem) => (
    <MenuItemCard key={menuItem.id} menuItem={menuItem} showFulfillment={true}>
      <MenuItemCardActions menuItem={menuItem} />
    </MenuItemCard>
  ));

  if (!menuItems.length) {
    return <></>;
  }

  return (
    <section>
      <div className="py-xxl">
        {/**
         * Remove the padding below the carousel to allow the margin above the
         * button to dictate the spacing between the two elements.
         */}
        <div className="-mb-md">
          <Carousel title="Featured menus near you">{cards}</Carousel>
        </div>
        <div className="mt-lg">
          <a
            href={`/search/shop?shopCategory=brand&shopName=${encodeURIComponent(
              brand.name
            )}`}
            className="button button--primary flex justify-center items-center flex-grow "
          >
            <CartIcon height="20" width="20" className="mr-sm" />
            shop all menus near you
          </a>
        </div>
      </div>
    </section>
  );
};

export default ShopNearbySection;
